export default __webpack_public_path__ + "static/media/91.97db6474.png";